import { Reducer } from 'redux'
import { CollectorStat } from './types'
import * as actions from './actions'

export type CollectorStatState = Readonly<{
  collectorStat: CollectorStat | null
  isLoading: boolean
}>

export const initState: CollectorStatState = {
  collectorStat: null,
  isLoading: false
}

export const statReducer: Reducer<CollectorStatState, actions.StatsActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_COLLECTOR_STATS_SUCCESS:
      return {
        ...state,
        collectorStat: action.payload
      }
    default:
      return state
  }
}
